import React from 'react'
import './Loading.scss'

import STYLE from '../../base'
import TPLogo from '../TPLogo/TPLogo'
import Spinner from '../Spinner/Spinner'

const Loading = () => (
  <div className="loading">
    <TPLogo primaryColor={STYLE.colors.neutral} secondaryColor={STYLE.colors.secondary} width="200" />
    <Spinner />
  </div>
)

export default Loading
